/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmExecuteAutomationTargetLocation {
    getFixupPrototypeFunction() { return AwsSsmExecuteAutomationTargetLocation.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmExecuteAutomationTargetLocation>): AwsSsmExecuteAutomationTargetLocation {
        let obj = Object.assign(new AwsSsmExecuteAutomationTargetLocation(), model);
        AwsSsmExecuteAutomationTargetLocation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmExecuteAutomationTargetLocation>): AwsSsmExecuteAutomationTargetLocation {
        if (!model) return null;
        return AwsSsmExecuteAutomationTargetLocation.newInstance(<AwsSsmExecuteAutomationTargetLocation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmExecuteAutomationTargetLocation) {
        if (!obj) return;

        models.AwsSsmExecuteAutomationTargetLocation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmExecuteAutomationTargetLocation): boolean {
        Object.setPrototypeOf(obj, AwsSsmExecuteAutomationTargetLocation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.target_alarm_configuration) {
            models.AwsSsmDocumentAlarmConfiguration.fixupPrototype(this.target_alarm_configuration);
        }
    }

    /**
     * The AWS accounts targeted by the current Automation execution.
     */
    accounts: Array<string>;

    /**
     * The Automation execution role used by the currently running Automation.
     */
    execution_role_name: string;

    /**
     * The AWS Regions targeted by the current Automation execution.
     */
    regions: Array<string>;

    /**
     * Details of the cloud watch alarm.
     */
    target_alarm_configuration: models.AwsSsmDocumentAlarmConfiguration;

    /**
     * The maximum number of AWS Regions and AWS accounts allowed to run the Automation concurrently.
     */
    target_location_max_concurrency: string;

    /**
     * The maximum number of errors allowed before the system stops queueing additional Automation executions for the currently running Automation.
     */
    target_location_max_errors: string;

}
